import React, {
  Component,
  Fragment
} from 'react';
import {Link} from 'react-router-dom';
import {
  ImgCover,
  PlayerButton,
  PlayerWrapper,
  PlayerVolumeWrapper,
  PlayerContainer,
  PlayerInfo,
  PlayerTextWrapper,
  PlayerText,
  WaveLoader
} from '../HelperComponents/StyledComponents';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Wavesurfer from 'wavesurfer.js';

import PropTypes from 'prop-types';

import Moment from 'moment';
import TuesdayCollectiveDefaultImg from '../../images/tuesday-collective-default.jpg';

import {
  getSonglistHash,
  stripUrlQueryParams,
} from '../../helpers';

import 'moment-duration-format';

import {
  fetchPlayerSong,
  playerSongPause,
  playerSongSetIsLoaded,
  playerSongPauseToggle,
} from '../../actions/PlayerActions';

const KEY_SPACEBAR = 32;
const KEY_LEFT = 37;
const KEY_RIGHT = 39;

const getPlaylistIndexOfSong = (playlist, songId) => {
  return playlist.findIndex(song => {return song.id === songId });
}

const hasPlaylistChanged = (props, prevProps) => {
  const playlist = props.playlist || [];
  const playlistPrev = prevProps.playlist || [];

  return getSonglistHash(playlist) !== getSonglistHash(playlistPrev);
};

const hasCurrentSongChanged = (props, prevProps) => {
  const currentSong = props.currentSong || {};
  const currentSongPrev = prevProps.currentSong || {};

  return currentSong.id !== currentSongPrev.id;
};

const hasIsPlayingStateChanged = (props, prevProps) => {
  return props.isPlaying !== prevProps.isPlaying;
};

const defaultSong = {
  title: {
    rendered: ''
  },
  product_file: {
    post_title: '',
    url: ''
  }
};

export class PlayerComponent extends Component {
  static propTypes = {
    title: PropTypes.string,
    artist: PropTypes.any,
    song: PropTypes.any,
    showPlayer: PropTypes.bool
  }

  state = {
    currentSongIndex: 0,
    pos: '0:00',
    duration: 0,
    volume: 0.75,
    volumeWidth: '75% 100%',
    song: defaultSong,
    showPlayer: 'none',
    showLoading: true
  }

  song = {
    _src: ''
  }

  componentDidMount () {
    // todo: #keyboardCommands unfortunately, we can't add this yet.
    // It takes over the keyboard on pages with forms as well. e.g. /profile/edit
    // document.addEventListener('keydown', this.handleOnKeyDown);
  }

  componentWillUnmount() {
    // todo: #keyboardCommands unfortunately, we can't add this yet.
    // document.removeEventListener('keydown');
  }

  handleOnKeyDown = (e) => {
    if (
      !this.props.currentSong ||
      ![KEY_SPACEBAR, KEY_LEFT, KEY_RIGHT].includes(e.keyCode)
    ) {
      return;
    }

    e.preventDefault();

    if (e.keyCode === KEY_SPACEBAR) {
      this.props.playerSongPauseToggle(this.props.isPlaying);
    } else if (e.keyCode === KEY_LEFT) {
      this.prevSong();
    } else if (e.keyCode === KEY_RIGHT) {
      this.nextSong();
    }
  };

  playSong = () => {
    this.props.playerSongPauseToggle(false);
  }

  pauseSong = () => {
    this.props.playerSongPause();
  }

  handleIsPlayingUpdate = () => {
    // this responds to the props changing in componentDidUpdate
    if (this.props.isPlaying) {
      this.songObject.play();
    } else {
      this.songObject.pause();
    }
  }

  handleVolumeChange = (event) => {
    let min = event.target.min,
      max = event.target.max,
      val = event.target.value;

    this.setState({ volume: val, volumeWidth: (val - min) * 100 / (max - min) + '% 100%' });
    this.songObject.setVolume(val);
  }

  prevSong = () => {
    const playlist = this.props.playlist;
    const currentSong = this.props.currentSong;
    const songIdx = getPlaylistIndexOfSong(playlist, currentSong.id);
    // if currentSong is the first song, this will be null
    const prevSong = playlist[songIdx - 1];

    if (prevSong) {
      this.props.fetchPlayerSong(prevSong);
    } else {
      this.pauseSong();
    }
  }

  nextSong = () => {
    const playlist = this.props.playlist;
    const currentSong = this.props.currentSong;
    const songIdx = getPlaylistIndexOfSong(playlist, currentSong.id);
    // if currentSong is the last song, this will be null
    const nextSong = playlist[songIdx + 1];

    if (nextSong) {
      this.props.fetchPlayerSong(nextSong);
    } else {
      this.pauseSong();
    }
  }

  cleanupOldWavesurferSong = () => {
    const oldSong = this.songObject;

    if (oldSong && oldSong.destroy) {
      oldSong.destroy();
      this.songObject = null;
    }
  }

  loadWavesurferSong = (song) => {
    this.cleanupOldWavesurferSong();

    if (song) {
      const songUrl = stripUrlQueryParams(song.product_file.url);

      this.setState({
        showLoading: true
      });

      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      let linGrad = ctx.createLinearGradient(0, 0, 170, 0);

      linGrad.addColorStop(0, '#745538');
      linGrad.addColorStop(0.5, '#62271e');
      linGrad.addColorStop(1, '#732618');

      let wavesurferSettings = {
        container: '#waveform',
        backend: 'MediaElement',
        height: 50,
        barWidth: 2,
        waveColor: linGrad,
        responsive: true,
        pixelRatio: 1,
        normalize: true,
        fillParent: true
      };

      this.songObject = Wavesurfer.create(wavesurferSettings);
      this.songObject.load(songUrl);

      this.songObject.setVolume(this.state.volume);

      this.songObject.on('ready', () => {
        this.props.playerSongSetIsLoaded();
        let durationFormat = Moment.duration(this.songObject.getDuration(), 'seconds').format();
        this.setState({ duration: durationFormat, showLoading: false });
      });

      this.songObject.on('audioprocess', (progress => {
        let minutes = Math.floor((progress % 3600) / 60);
        let seconds = ('00' + Math.floor(progress % 60)).slice(-2);
        let currentTime = `${minutes}:${seconds}`;

        if (this.state.pos !== currentTime) {
          this.setState({
            pos: currentTime
          });
        }
      }));

      this.songObject.on('finish', () => {
        this.nextSong();
      });
    }
  }

  componentDidUpdate(prevProps) {
    // I don't think we need to handle this event here.
    if (hasPlaylistChanged(this.props, prevProps)) {}

    if(hasCurrentSongChanged(this.props, prevProps)) {
      this.loadWavesurferSong(this.props.currentSong);
      this.handleIsPlayingUpdate();
      return;
    }

    if(hasIsPlayingStateChanged(this.props, prevProps)) {
      this.handleIsPlayingUpdate();
    }
  }

  currentSongIndex = 0;

  render() {
    const song = this.props.currentSong || defaultSong;

    let album = song.product_album || {};

    const songIdx = getPlaylistIndexOfSong(this.props.playlist, song.id);
    const isNextButtonActive = songIdx >= 0 && songIdx < this.props.playlist.length - 1;
    const isPreviousButtonActive = songIdx > 0;

    const PlayerState = this.props.isLoading ?
      <PlayerButton className="icon-play is-loading" theme={{ padding: '10px', fontSize: '40px' }}></PlayerButton> :
      this.props.isPlaying ?
        <PlayerButton className="icon-pause" onClick={this.pauseSong} theme={{ padding: '10px', fontSize: '40px' }}></PlayerButton> :
        <PlayerButton className="icon-play" onClick={this.playSong} theme={{ padding: '10px', fontSize: '40px' }}></PlayerButton>;
    const nextButtonStyles = isNextButtonActive ? {} : { color: 'gray', pointerEvents: 'none' };
    const previousButtonStyles = isPreviousButtonActive ? {} : { color: 'gray', pointerEvents: 'none' };
    const albumUrl = stripUrlQueryParams(album.url);

    return (
      <Fragment>
        <nav className="is-black navbar is-marginless is-fixed-bottom columns" style={{ display: this.props.showPlayer ? 'block' : 'none'}}>
          <section className="column is-full">
            <PlayerContainer className="columns is-variable is-1 is-vcentered is-centered is-mobile is-multiline">
              <PlayerInfo className="column is-3-desktop is-12-mobile has-text-centered-mobile is-paddingless is-flex-desktop" >
                <figure className="image is-48x48 is-inline-block is-hidden-touch" style={{ margin: '0 10px' }}>
                  <ImgCover className="is-hidden-mobile" src={albumUrl || TuesdayCollectiveDefaultImg} />
                </figure>
                <PlayerTextWrapper className="is-inline-block">
                  <PlayerText className="has-text-white">
                    {song.post_title ? song.post_title : song.title.rendered }
                    <span className="is-hidden-desktop"> - </span>
                    <span className="is-block-desktop" style={{ fontSize: '12px' }}>
                      <Link to={`/album/${album.id}`} style={{ color: 'white' }}>{(album.post_title ? album.post_title : '')}</Link>
                    </span>
                  </PlayerText>

                </PlayerTextWrapper>
              </PlayerInfo>

              <PlayerWrapper className="column is-narrow">
                <PlayerButton className="icon-backward" theme={{ fontSize: '24px' }} style={{ margin: '0 10px', ...previousButtonStyles }} onClick={this.prevSong}></PlayerButton>
                <section>
                  { PlayerState }
                </section>
                <PlayerButton className="icon-forward" theme={{ fontSize: '24px' }} style={{ margin: '0 10px', ...nextButtonStyles }} onClick={this.nextSong}></PlayerButton>
              </PlayerWrapper>

              <section className="column is-4-desktop is-half-mobile">
                <section className="columns is-vcentered is-mobile">
                  <section className="column is-narrow">
                    <p>{this.state.pos}</p>
                  </section>
                  <section className="column is-10-desktop is-8-tablet has-text-centered" style={{ position: 'relative' }}>
                    <section style={{ position: 'absolute', height: '65%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <WaveLoader style={{ display: this.state.showLoading ? 'block' : 'none' }}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </WaveLoader>
                    </section>

                    <div id="waveform"></div>
                  </section>
                  <section className="column is-narrow">
                    <p>{this.state.duration}</p>
                  </section>
                </section>
              </section>

              <PlayerVolumeWrapper className="column is-narrow is-hidden-mobile">
                <PlayerButton className="icon-volume-up" theme={{ fontSize: '20px' }}></PlayerButton>
                <span style={{ marginLeft: '10px'  }}>
                  <input
                    id="vol-control"
                    type="range" min="0" max="1" step="0.1"
                    value={this.state.volume}
                    onChange={this.handleVolumeChange}
                    style={{ backgroundSize: this.state.volumeWidth, verticalAlign: 'super' }}
                  >
                  </input>
                </span>

              </PlayerVolumeWrapper>
            </PlayerContainer>
          </section>
        </nav>
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  const {
    playerSong,
    showPlayer,
    playlist,
  } = state;

  const {
    isFetching,
    isPlaying,
    isLoading,
    currentSong,
  } = playerSong || {
    isFetching: true,
    isLoading: false,
    showPlayer: false,
    currentSong: null,
    isPlaying: null,
  };

  return {
    showPlayer,
    isFetching,
    isLoading,
    isPlaying,
    playlist,
    currentSong,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchPlayerSong,
    playerSongPause,
    playerSongSetIsLoaded,
    playerSongPauseToggle,
  }, dispatch);
}

export const Player = connect(mapStateToProps, mapDispatchToProps)(PlayerComponent);



// WEBPACK FOOTER //
// ./src/components/Player/Player.js